var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "8" } },
            [
              _c("v-subheader", [_vm._v("Aircraft Info")]),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "no-footer-table",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.plain_logs,
                  "items-per-page": 30,
                  flat: ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.oil",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        item.oil
                          ? _c("span", [_vm._v(_vm._s(item.oil) + " qts")])
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "item.fuel",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        item.fuel
                          ? _c("span", [_vm._v(_vm._s(item.fuel) + " gal")])
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "item.actions",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        !item.logID
                          ? _c(
                              "v-btn",
                              {
                                staticClass: "blue--text",
                                attrs: { icon: "", small: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.logInfo(item)
                                  }
                                }
                              },
                              [
                                _c("v-icon", { attrs: { left: "" } }, [
                                  _vm._v("mdi-clipboard-edit-outline")
                                ])
                              ],
                              1
                            )
                          : _c(
                              "v-btn",
                              {
                                staticClass: "blue--text",
                                attrs: { icon: "", small: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.edit(item)
                                  }
                                }
                              },
                              [
                                _c("v-icon", { attrs: { center: "" } }, [
                                  _vm._v("mdi-clipboard-edit")
                                ])
                              ],
                              1
                            )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "4" } },
            [
              _c("v-data-table", {
                staticClass: "no-footer-table",
                attrs: {
                  items: _vm.resources,
                  headers: _vm.stockHeaders,
                  flat: ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.actions",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "blue", icon: "", small: "" },
                            on: {
                              click: function($event) {
                                return _vm.addResources(item)
                              }
                            }
                          },
                          [
                            _c("v-icon", { attrs: { center: "" } }, [
                              _vm._v("mdi-plus")
                            ])
                          ],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "item.qty",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          "\n\n          " +
                            _vm._s(item.qty) +
                            " " +
                            _vm._s(item.unit) +
                            "\n\n        "
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "600px" },
          on: {
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              ) {
                return null
              }
              _vm.dialog = false
            }
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-form",
            {
              ref: "form",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save($event)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card",
                { attrs: { color: "lighten-1" } },
                [
                  _c(
                    "v-toolbar",
                    [
                      _c("v-toolbar-title", [
                        _c("span", { staticClass: "headline" }, [
                          _vm._v(_vm._s(_vm.formTitle))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-spacer")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "fieldset",
                        { staticClass: "inline-form input-4" },
                        [
                          _c("v-text-field", {
                            attrs: { label: "Hobbs", type: "number" },
                            model: {
                              value: _vm.editedItem.hobbs,
                              callback: function($$v) {
                                _vm.$set(_vm.editedItem, "hobbs", $$v)
                              },
                              expression: "editedItem.hobbs"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: { label: "Tachtime", type: "number" },
                            model: {
                              value: _vm.editedItem.tachtime,
                              callback: function($$v) {
                                _vm.$set(_vm.editedItem, "tachtime", $$v)
                              },
                              expression: "editedItem.tachtime"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: {
                              disabled:
                                _vm.editedIndex > -1 || !_vm.viewingToday,
                              label: "Oil",
                              type: "number",
                              suffix: "qts"
                            },
                            model: {
                              value: _vm.editedItem.oil,
                              callback: function($$v) {
                                _vm.$set(_vm.editedItem, "oil", $$v)
                              },
                              expression: "editedItem.oil"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: {
                              disabled:
                                _vm.editedIndex > -1 || !_vm.viewingToday,
                              label: "Fuel",
                              type: "number",
                              suffix: "gal"
                            },
                            model: {
                              value: _vm.editedItem.fuel,
                              callback: function($$v) {
                                _vm.$set(_vm.editedItem, "fuel", $$v)
                              },
                              expression: "editedItem.fuel"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: { label: "Squawks" },
                        model: {
                          value: _vm.editedItem.squawks,
                          callback: function($$v) {
                            _vm.$set(_vm.editedItem, "squawks", $$v)
                          },
                          expression: "editedItem.squawks"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", text: "" },
                          on: { click: _vm.close }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "blue darken-1",
                            type: "submit",
                            disabled: !_vm.valid
                          }
                        },
                        [_vm._v("Save")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }